import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const useDetailWrapper = ({
  typeIdToDisplayName,
  primaryDetailRecord,
  finalAuxiliaryRecords,
  bulkUpdateCallBack
}) => {
  const navigate = useNavigate()
  const entityTypeDisplayName = typeIdToDisplayName
    ? typeIdToDisplayName(
        primaryDetailRecord?.type
          ? primaryDetailRecord?.type
          : primaryDetailRecord?.type_id
      )
    : ''

  const [isSnackbarOpen, setIsSnackbarOpen] = useState({
    isOpen: false,
    message: `${entityTypeDisplayName} saved`,
    severity: 'success'
  })

  /// Because the 'bulk' operation is only ever touching two system columns of the record
  /// its attack interface is actually smaller than the regular single record update
  const doSingleActivationOrDeleteOnBulkAPI = (isDelete, id, checked) => {
    const bulkUpdateParameters = []
    if (isDelete) {
      bulkUpdateParameters.push({
        id,
        deleted_at: Date.now()
      })
    } else {
      bulkUpdateParameters.push({
        id,
        suspended_at: checked ? null : Date.now()
      })
    }
    bulkUpdateCallBack(bulkUpdateParameters)
      .unwrap()
      .then(() => {
        if (isDelete) {
          // go back to summary
          navigate(-1)
        } else {
          // in-place rerender
          navigate(0)
        }
      })
      .catch(e => {
        alert(JSON.stringify(e))
      })
  }

  const constructWarningMessage = (isDelete, checked) => {
    const allBuckets = finalAuxiliaryRecords.segundo.concat(
      finalAuxiliaryRecords.tercero
    )
    let recordcount = 0
    let finalMessage = isDelete
      ? 'Deleting this record will also delete '
      : checked
      ? 'Activating this record will also activate '
      : 'Deactivating this record will also deactivate '
    allBuckets.filter(Boolean).forEach(o => {
      if (
        o.listPropertyName === 'inherit_ids' ||
        o.listPropertyName === 'items'
      ) {
        if (o.selection.length > 0) {
          finalMessage += `${
            o.selection.length
          } assigned ${o.picklistEntityDisplayName.toLowerCase()}s, `
          recordcount++
        }
      }
    })
    if (recordcount === 0) { finalMessage+= 'no additional records '}
    finalMessage += 'are you sure you want to continue?'
    return finalMessage
  }
  const deleteEntityCallback = (callback = null) => id => {
    const goAhead = window.confirm(constructWarningMessage(true))
    if (goAhead) {
      callback ? callback(id) : doSingleActivationOrDeleteOnBulkAPI(true, id)
    }
  }

  const activationChangeCallback = (callback = null) => (id, checked) => {
    const goAhead = window.confirm(constructWarningMessage(false, checked))

    if (goAhead) {
      callback ? callback(id, checked) : doSingleActivationOrDeleteOnBulkAPI(false, id, checked)
    }
  }

  return {
    isSnackbarOpen,
    setIsSnackbarOpen,
    deleteEntityCallback,
    activationChangeCallback,
    stageActivationChange: formikProps => activationChangeCallback((_id, active) => {
      formikProps.setFieldValue('suspended_at', active ? null : new Date().toISOString())
    })
  }
}

export default useDetailWrapper
